import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { fakeAffiliate } from './affiliate.fake';
import {
    AffiliateEndpoint as AffiliateEndpointModel,
    BookingTrackingRQ,
    BookingTrackingRS,
} from './affiliate.interfaces';
import affiliateFakeJSON from '@/api/Affiliate/affiliate.fake.json';
import { configBase } from '@/config/base';

const affiliateEndpoint = configBase.devMode.enabled
    ? 'affiliate/getbookingtracking'
    : '/mvc/Affiliate/GetBookingTracking';

export class AffiliateEndpoint extends HttpEndpoint implements AffiliateEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }
    public GetBookingTracking(model: BookingTrackingRQ): Promise<BookingTrackingRS> {
        return this.post(affiliateEndpoint, model);
    }
}

export class FakeAffiliateEndpoint implements AffiliateEndpointModel {
    public async GetBookingTracking(): Promise<BookingTrackingRS> {
        await delay(1000);

        const hasJSON = affiliateFakeJSON && Object.keys(affiliateFakeJSON).length > 0;

        if (hasJSON) {
            return affiliateFakeJSON as any;
        } else {
            return fakeAffiliate;
        }
    }
}
